package com.milta.feature.route.data.remote.dto

import com.milta.feature.route.domain.entity.DriverRouteOverview
import com.milta.feature.route.domain.entity.RouteStatus
import com.milta.feature.route.domain.entity.TeamRoutesOverview
import kotlinx.serialization.Serializable

/** Mirrors backend `TeamRoutesOverviewDto` (MIL-38 — `GET /api/v1/routes`, Manager team dashboard). */
@Serializable
data class TeamRoutesOverviewDto(
    val date: String,
    val totalRoutes: Int,
    val totalDeliveries: Int,
    val completedDeliveries: Int,
    val routes: List<DriverRouteOverviewDto> = emptyList(),
)

/** Mirrors backend `DriverRouteOverviewDto` — one entry of `TeamRoutesOverviewDto.routes`. */
@Serializable
data class DriverRouteOverviewDto(
    val routeId: String,
    val driverId: String,
    val driverFirstName: String,
    val driverLastName: String,
    val status: String,
    val startedAt: String? = null,
    val completedAt: String? = null,
    val completedStopsCount: Int,
    val totalStopsCount: Int,
    // Défaut 0 : une réponse d'un backend plus ancien (avant ce champ) se décode quand même.
    val totalPackagesCount: Int = 0,
    // Répartition entre plusieurs chauffeurs ; null = tournée d'un seul chauffeur (ou ancien backend).
    val batchId: String? = null,
    val failedStopsCount: Int = 0,
    val untreatedStopsCount: Int = 0,
)

fun TeamRoutesOverviewDto.toDomain() = TeamRoutesOverview(
    date = date,
    totalRoutes = totalRoutes,
    totalDeliveries = totalDeliveries,
    completedDeliveries = completedDeliveries,
    routes = routes.map { it.toDomain() },
)

fun DriverRouteOverviewDto.toDomain() = DriverRouteOverview(
    routeId = routeId,
    driverId = driverId,
    driverFirstName = driverFirstName,
    driverLastName = driverLastName,
    status = when (status) {
        "InProgress" -> RouteStatus.InProgress
        "Completed"  -> RouteStatus.Completed
        else         -> RouteStatus.Scheduled
    },
    startedAt = startedAt,
    completedAt = completedAt,
    completedStopsCount = completedStopsCount,
    totalStopsCount = totalStopsCount,
    totalPackagesCount = totalPackagesCount,
    batchId = batchId,
    failedStopsCount = failedStopsCount,
    untreatedStopsCount = untreatedStopsCount,
)
